import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=c4e85f3a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4e85f3a')) {
      api.createRecord('c4e85f3a', component.options)
    } else {
      api.reload('c4e85f3a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=c4e85f3a&", function () {
      api.rerender('c4e85f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nRp41j0RQTsn/JS/comp/ImgFallback.vue"
export default component.exports